// Shared with the server's meeting_platform.rs so the Meetings page and the
// notetaker join button agree on FR-M2 / FR-M3a / FR-M3c without a second guess.

export type MeetingPlatform = "meet" | "zoom" | "teams" | "other";

export function detectPlatform(url: string): MeetingPlatform {
  const lower = url.trim().toLowerCase();
  if (lower.includes("meet.google.com")) return "meet";
  if (lower.includes("zoom.us/") || lower.includes("zoom.com/")) return "zoom";
  if (lower.includes("teams.microsoft.com") || lower.includes("teams.live.com")) return "teams";
  return "other";
}

/** FR-M3 / FR-M3a / FR-M3c: the bot joins Meet, Zoom and Teams. Meet also keeps the
 * extension (FR-M2) — the two are not exclusive. Mirrors `MeetingPlatform::bot_supported`. */
export function botSupported(platform: MeetingPlatform): boolean {
  return platform === "meet" || platform === "zoom" || platform === "teams";
}

export function platformLabel(platform: MeetingPlatform): string {
  switch (platform) {
    case "meet":
      return "Google Meet";
    case "zoom":
      return "Zoom";
    case "teams":
      return "Microsoft Teams";
    default:
      return "No conference link";
  }
}

/** One key per meeting, mirroring the server's `meeting_platform::meeting_key`, so a
 * colleague's notetaker shows on your copy of the same invite: Zoom by meeting number, others by
 * host and path, lowercased, ignoring query, fragment and a trailing slash. */
export function meetingKey(url: string): string {
  const zoom = /\/(?:j|s|wc\/join|wc)\/(\d{9,13})(?!\d)/i.exec(url);
  if (zoom) return `zoom:${zoom[1]}`;
  try {
    const parsed = new URL(url.trim());
    return `${parsed.hostname}${parsed.pathname.replace(/\/+$/, "")}`.toLowerCase();
  } catch {
    return url.trim().toLowerCase();
  }
}
